"use client";

import { Authentication } from "@/components/Authentication/Wrapper";

const AuthenticationClient: React.FC<any> = () => {
  return (
    <div className="content-wrapper">
      <div className="md:mt-20">
        <Authentication />
      </div>
    </div>
  );
};

export default AuthenticationClient;
